import { Component, inject, output, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SynButtonComponent, SynRadioComponent, SynRadioGroupComponent } from '@synergy-design-system/angular';
import { TokenMapperType } from '../../types';

@Component({
  selector: 'app-choose-token-mapper-type',
  template: `
    <syn-radio-group label="Mapper Type" i18n-label="@@mapper-type" [(value)]="mapperType">
      <syn-radio value="userAttribute" i18n="@@user-attribute">User Attribute</syn-radio>
      <span class="margin-bottom-1" i18n="@@user-attribute-mapper-description">
        Map a specific user attribute into the token.
        For example, to map the customer number attribute, you can map
        the <code>y_CustomerNumber</code> attribute to the claim
        <code>myCustomerNumber</code> in the user's token.
      </span>
      <syn-radio value="audience" i18n="@@audience">Audience</syn-radio>
      <span class="margin-bottom-1" i18n="@@audience-mapper-description">
        Map a specific client or custom audience into the user's token.
        Applications should verify that the token they receive has been issued for
        the correct audience. Ususally, this can be a specific client ID.
        Some applications may require a custom audience.
      </span>
      <syn-radio value="clientRoles" i18n="@@client-roles">Client Roles</syn-radio>
      <span class="margin-bottom-1" i18n="@@client-roles-mapper-description">
        Map all roles of another client into the user's token.
        This may be necessary if your application needs to check if the user has roles for another client.
        Another use case would be tokens that are used for multiple applications / audiences.
      </span>
    </syn-radio-group>

    <!-- Do we want to offer more mapping possibilities here? -->
    <!-- If they are not used or useful for our users, we should just omit them -->

    <div class="flex-row margin--top-1">
      <syn-button variant="filled" style="margin-left: auto" (click)="onNext()" i18n="@@next">Next</syn-button>
    </div>
  `,
  styles: [],
  imports: [
    SynRadioGroupComponent,
    SynButtonComponent,
    SynRadioComponent,

  ],
})
export class ChooseTokenMapperTypeComponent {
  clientId = inject(ActivatedRoute).snapshot.params['id'];

  mapperType = signal('userAttribute' as TokenMapperType);
  selected = output<TokenMapperType>();


  onNext() {
    this.selected.emit(this.mapperType());
  }
}
